import { render, staticRenderFns } from "./PrevButton.vue?vue&type=template&id=2053a35c&scoped=true&"
import script from "./PrevButton.vue?vue&type=script&lang=js&"
export * from "./PrevButton.vue?vue&type=script&lang=js&"
import style0 from "./PrevButton.vue?vue&type=style&index=0&id=2053a35c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2053a35c",
  null
  
)

export default component.exports